export type PhoneSegment =
	| { type: "text"; display: string }
	| { type: "phone"; display: string; href: string };

const phonePattern = /\+?\d[\d\s-]{6,}\d/g;

export function parsePhoneSegments(text: string): PhoneSegment[] {
	const segments: PhoneSegment[] = [];
	let lastIndex = 0;

	for (const match of text.matchAll(phonePattern)) {
		const display = match[0];
		const index = match.index ?? 0;
		if (index > lastIndex) {
			segments.push({ type: "text", display: text.slice(lastIndex, index) });
		}
		segments.push({ type: "phone", display, href: toTelHref(display) });
		lastIndex = index + display.length;
	}

	if (lastIndex < text.length) {
		segments.push({ type: "text", display: text.slice(lastIndex) });
	}

	return segments;
}

function toTelHref(display: string): string {
	const compact = display.replace(/[\s-]/g, "");
	if (compact.startsWith("+")) {
		return `+${compact.slice(1).replace(/\D/g, "")}`;
	}
	return compact.replace(/\D/g, "");
}
